import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function fetchDailyTasks() {
  const token = getToken();
  const res = await axios.get(`${API}/cabin/daily-tasks`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  // Backend may return { tasks: [...] } or plain array
  const tasks = Array.isArray(res.data) ? res.data : (res.data?.tasks ?? res.data);
  return tasks;
}

export function useDailyTasks() {
  return useQuery({
    queryKey: ['cabin', 'daily-tasks'],
    queryFn: fetchDailyTasks,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    enabled: typeof window !== 'undefined' && !!getToken(),
  });
}
